import { Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { API, fileUpload, imageDefaultPrefixPath, metaTitle } from "../../../config";
import { formatName, formatedAddress } from "../../common/Misc";
import Spin from "../../common/Spin";
import { AddClientSchema } from "../../common/Validation";
import {
  useManagerList,
  useOfficeList,
  useStaffList,
  useStateList,
  useSuburbListE,
} from "./components/ClientHelper";
import Form from "./components/Form";
import { Button, Modal } from "react-bootstrap";
import TitleBar from "../../common/TitleBar";

const AddClients = () => {
  const navigate = useNavigate();
  const [clientData, setClientData] = useState();
  const [showInviteClient, setShowInviteClient] = useState(false);
  const [newClientId, setNewClientId] = useState();
  const [newClientEmail, setNewClientEmail] = useState();

  const [loading, setLoading] = useState(false);
  const [clientInviteLoading, setClientInviteLoading] = useState(false);

  const formValues = useRef();
  let existingValues = [];
  let overwrittenFields = [];
  const handleFormSubmit = async (value) => {
    const formData = new FormData();

    value.profile_pic = value?.image
      ? value?.image
      : value?.profile_pic
      ? value?.profile_pic
      : "";

    value.phone = value?.phone ? `${value?.phone}`.replace(/ /g, "") : "";
    value.mobile = value?.mobile ? `${value?.mobile}`.replace(/ /g, "") : "";
    value.abn = value?.abn ? `${value?.abn}`.replace(/ /g, "") : "";
    // value.entity_type = value?.entity_type?.value;

    value.state_id = value?.state_id?.value;
    value.suburb_id = value?.suburb_id?.value;

    value.shipping_state_id = value?.shipping_state_id?.value;
    value.shipping_suburb_id = value?.shipping_suburb_id?.value;

    value.staff_id = value?.staff_id?.value;
    value.manager_id = value?.manager_id?.value;
    value.office_id = value?.office_id?.value;

    formData.append("first_name", value?.first_name ? value?.first_name : "");
    formData.append("last_name", value?.last_name ? value?.last_name : "");
    formData.append("phone", value?.phone ? value?.phone : "");
    formData.append("mobile", value?.mobile ? value?.mobile : "");
    formData.append("email", value?.email ? value?.email : "");
    formData.append(
      "business_name",
      value?.business_name ? value?.business_name : ""
    );
    formData.append(
      "display_name",
      value?.display_name ? value?.display_name : ""
    );
    formData.append("abn", value?.abn ? value?.abn : "");
    // formData.append(
    //   "entity_type",
    //   value?.entity_type ? value?.entity_type : ""
    // );
    formData.append("crn", value?.crn ? value?.crn : "");
    formData.append(
      "profile_pic",
      value?.profile_pic ? value?.profile_pic : ""
    );
    formData.append("street", value?.street ? value?.street : "");
    formData.append("state_id", value?.state_id ? value?.state_id : "");
    formData.append("suburb_id", value?.suburb_id ? value?.suburb_id : "");
    formData.append(
      "postal_code",
      value?.postal_code ? value?.postal_code : ""
    );
    formData.append(
      "shipping_street",
      value?.shipping_street ? value?.shipping_street : ""
    );
    formData.append(
      "shipping_state_id",
      value?.shipping_state_id ? value?.shipping_state_id : ""
    );
    formData.append(
      "shipping_suburb_id",
      value?.shipping_suburb_id ? value?.shipping_suburb_id : ""
    );
    formData.append(
      "shipping_postal_code",
      value?.shipping_postal_code ? value?.shipping_postal_code : ""
    );
    formData.append("staff_id", value?.staff_id ? value?.staff_id : "");
    formData.append("manager_id", value?.manager_id ? value?.manager_id : "");
    formData.append("office_id", value?.office_id ? value?.office_id : "");

    try {
      setLoading(true);
      const { data } = await fileUpload(`${API.CLIENT_ADD}`, formData);
      setLoading(false);
      if (data) {
        // toast.success(data?.message);
        setNewClientId(data?.data?.id);
        setNewClientEmail(data?.data?.email);
        toggleInviteClientModal();
      }
      return data?.data;
    } catch (error) {
      setClientData(value);
      if (error?.response?.data?.errors) {
        Object.keys(error?.response?.data?.errors).forEach((key) => {
          toast.error(error?.response?.data?.errors[key][0]);
        });
        setLoading(false);
      } else {
        toast.error(error?.message);
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    window.document.title = `${metaTitle} | Add Client`
  },[])

  // State
  const { stateLoading, stateList = [] } = useStateList();
  const stateListing = stateList?.map((item) => {
    const { name: label, id: value, ...rest } = item;
    return { label, value, ...rest };
  });
  const state = stateListing?.find(
    (item) =>
      item?.value ===
      (clientData?.state_id
        ? clientData?.state_id
        : clientData?.client?.state_id)
  );
  const shippingState = stateListing?.find(
    (item) =>
      item?.value ===
      (clientData?.shipping_state_id
        ? clientData?.shipping_state_id
        : clientData?.client?.shipping_state_id)
  );

  // Suburb
  const { suburbLoading, suburbList = [] } = useSuburbListE(
    clientData?.state_id
  );
  const suburbListing = suburbList?.map((item) => {
    const { name: label, id: value, ...rest } = item;
    return { label, value, ...rest };
  });
  const suburb = suburbListing?.find(
    (item) =>
      item?.value ===
      (clientData?.suburb_id
        ? clientData?.suburb_id
        : clientData?.client?.suburb_id)
  );

  // ShippingSuburb
  const { suburbLoading2, shippingSuburbList = [] } = useSuburbListE(
    clientData?.shipping_state_id
  );
  const shippingSuburbListing = shippingSuburbList?.map((item) => {
    const { name: label, id: value, ...rest } = item;
    return { label, value, ...rest };
  });
  const shippingSuburb = shippingSuburbListing?.find((item) =>
    item?.value === clientData?.shipping_suburb_id
      ? clientData?.shipping_suburb_id
      : clientData?.client?.shipping_suburb_id
  );

  //Office List
  const { officeLoading, officeList = [] } = useOfficeList();
  const officeListing = officeList?.map((item) => {
    const name = formatedAddress(item?.street, item?.suburb?.name, item?.state?.short_name, item?.postal_code);
    const id = item?.id;
    const items = { name, id };
    const { name: label, id: value, ...rest } = items;
    return { label, value, ...rest };
  });
  const office = officeListing?.find(
    (item) =>
      item?.value ===
      (clientData?.office_id
        ? clientData?.office_id
        : clientData?.client?.office_id)
  );

  const { managerLoading, managerList = [] } = useManagerList();
  const managerListing = managerList?.map((item) => {
    const name = formatName(item?.first_name, item?.last_name);
    const id = item?.id;
    const items = { name, id };
    const { name: label, id: value, ...rest } = items;
    return { label, value, ...rest };
  });
  const manager = managerListing?.find(
    (item) =>
      item?.value ===
      (clientData?.manager_id
        ? clientData?.manager_id
        : clientData?.client?.manager_id)
  );

  const { staffLoading, staffList = [] } = useStaffList();
  const staffListing = staffList?.map((item) => {
    const name = formatName(item?.first_name, item?.last_name);
    const id = item?.id;
    const items = { name, id };
    const { name: label, id: value, ...rest } = items;
    return { label, value, ...rest };
  });
  const staff = staffListing?.find(
    (item) =>
      item?.value ===
      (clientData?.staff_id
        ? clientData?.staff_id
        : clientData?.client?.staff_id)
  );

  const toggleInviteClientModal = () => {
    setShowInviteClient(!showInviteClient)
  }

  const handleInvite = async() => {
    const formData = new FormData();

    formData.append("email", newClientEmail ? newClientEmail : "");
    formData.append("client_id", newClientId ? newClientId : "");

    try {
      setClientInviteLoading(true);
      const { data } = await fileUpload(
        `${API.INVITE_CLIENT}`,
        formData
      );
      setClientInviteLoading(false);
      if (data) {
        toast.success(data?.message);
        toggleInviteClientModal();
        navigate("/clients");
      }
      return data?.data;
    } catch (error) {
      setClientInviteLoading(false);
      if (error?.response?.data?.errors) {
        Object.keys(error?.response?.data?.errors).forEach((key) => {
          toast.error(error?.response?.data?.errors[key][0]);
        });
        setClientInviteLoading(false);
      } else {
        toast.error(error?.message);
        setClientInviteLoading(false);
      }
    }
  }

  return (
    <>
    <div className="cms-page">
      <div className="page-content-block">
        <div className="full-content-block">
          <TitleBar
            label={"New Client"}
            businessNameData={false}
            globalSearch={false}
          /> 
          <div className="content-details">
            <section>
              <Formik
                initialValues={{
                  first_name: clientData?.first_name,
                  last_name: clientData?.last_name,
                  phone: clientData?.phone,
                  mobile: clientData?.mobile,
                  email: clientData?.email,
                  business_name: clientData?.business_name
                    ? clientData?.business_name
                    : clientData?.client?.business_name,
                  display_name: clientData?.display_name
                    ? clientData?.display_name
                    : clientData?.client?.display_name,
                  abn: clientData?.abn
                    ? clientData?.abn
                    : clientData?.client?.abn,
                  // entity_type: entityTypes?.find(
                  //   (item) => item?.value === clientData?.client?.entity_type
                  // ),
                  crn: clientData?.crn
                    ? clientData?.crn
                    : clientData?.client?.crn,
                  profile_pic: clientData?.profile_pic
                    ? imageDefaultPrefixPath + clientData?.profile_pic
                    : "",
                  street: clientData?.street
                    ? clientData?.street
                    : clientData?.client?.street,
                  state_id: state,
                  suburb_id: suburb,
                  postal_code: clientData?.postal_code
                    ? clientData?.postal_code
                    : clientData?.client?.postal_code,

                  shipping_street: clientData?.shipping_street
                    ? clientData?.shipping_street
                    : clientData?.client?.shipping_street,
                  shipping_state_id: shippingState,
                  shipping_suburb_id: shippingSuburb,
                  shipping_postal_code: clientData?.shipping_postal_code
                    ? clientData?.shipping_postal_code
                    : clientData?.client?.shipping_postal_code,

                  staff_id: staff,
                  manager_id: manager,
                  office_id: office,
                }}
                enableReinitialize={true}
                innerRef={formValues}
                onSubmit={(value) => {
                  handleFormSubmit(value);
                }}
                validateOnBlur={true}
                validateOnChange={true}
                validationSchema={AddClientSchema}
              >
                {({
                  values,
                  setErrors,
                  errors,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  setFieldValue,
                }) => {
                  return (
                    <>
                      {loading && <Spin />}
                      <Form
                        values={values}
                        errors={errors}
                        setErrors={setErrors}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        handleSubmit={handleSubmit}
                        setFieldValue={setFieldValue}
                        formValues={formValues}
                        overwrittenFields={overwrittenFields}
                        existingValues={existingValues}
                        stateListing={stateListing}
                        stateLoading={stateLoading}
                        officeListing={officeListing}
                        officeLoading={officeLoading}
                        managerListing={managerListing}
                        managerLoading={managerLoading}
                        staffListing={staffListing}
                        staffLoading={staffLoading}
                        erSuburbLoading={suburbLoading}
                        erSuburbLoading2={suburbLoading2}
                      />
                    </>
                  );
                }}
              </Formik>
            </section>
          </div>
        </div>
      </div>
    </div>
    {showInviteClient && (
      <Modal
        size="lg"
        show={showInviteClient}
        onHide={toggleInviteClientModal}
        dialogClassName="modal-50w small-popup review-popup small-review"
        aria-labelledby="contained-modal-title-vcenter"
        className="business-section"
        centered
      >
        <Modal.Header className="mb-0" closeButton>
          Inviting Client
        </Modal.Header>
        <Modal.Body>
          {clientInviteLoading && <Spin />}
          <div className="modal-body">
            Do you want to invite the client?
          </div>
          <div className="modal-footer">
          <Button
              type="submit"
              className="btn btn-primary"
              data-dismiss="modal"
              onClick={() => {
                handleInvite();
              }}
            >
              Yes
            </Button>
            <Button
              type="Button"
              className="btn btn-secondary"
              onClick={() => {
                toggleInviteClientModal();
                navigate("/clients");
              }}
            >
              No
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    )}
    </>
  );
};

export default AddClients;
